import { render, staticRenderFns } from "./official-policy.vue?vue&type=template&id=a137dbd6&scoped=true&"
import script from "./official-policy.vue?vue&type=script&lang=js&"
export * from "./official-policy.vue?vue&type=script&lang=js&"
import style0 from "./official-policy.vue?vue&type=style&index=0&id=a137dbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a137dbd6",
  null
  
)

export default component.exports